import { useRef } from 'react';
import { renderCanvas } from '../utils/canvasRenderer.js';

const CANVAS_SIZE = 1080;

export default function DownloadButton({ storyData }) {
  const downloadCanvasRef = useRef(null);

  const handleDownload = async () => {
    if (!storyData.backgroundImage) {
      alert('Please upload a background image first');
      return;
    }

    const canvas = downloadCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    try {
      await renderCanvas(ctx, storyData, CANVAS_SIZE);
    } catch (err) {
      console.error('Canvas download render error:', err);
      alert('Failed to render image. Please try again.');
      return;
    }

    canvas.toBlob((blob) => {
      if (blob) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'instagram-graphic.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    }, 'image/png');
  };

  return (
    <>
      <canvas ref={downloadCanvasRef} width={CANVAS_SIZE} height={CANVAS_SIZE} style={{ display: 'none' }} />
      <button type="button" onClick={handleDownload} className="download-btn" disabled={!storyData.backgroundImage}>
        Download PNG
      </button>
    </>
  );
}
